import styled from "styled-components";

export const Tag = styled.div`
  background: ${props => props.backgroundColor};
  display: inline-flex;
  align-self: flex-start;
  border-radius: 5px;
  font-size: 12px;
  padding: 5px 8px 5px 22px;
  line-height: 20px;
  position: relative;
  white-space: nowrap;

  &::before {
    content: "";
    position: absolute;
    top: 50%;
    left: 8px;
    transform: translateY(-50%);
    width: 6px;
    height: 6px;
    background-color: ${(props) => props.dotColor};
    border-radius: 50%;
  }
`;
